(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-accordion')) {
  customElements.define('tl-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const reserveSpace = () => {
        const entries = [...this.querySelectorAll('details')];
        if (entries.some(item => item.tlAnimation)) return;
        let closedHeight = 0, largestAnswer = 0;
        entries.forEach(item => {
          const wasOpen = item.open;
          item.open = false;
          const closed = item.getBoundingClientRect().height;
          item.open = true;
          largestAnswer = Math.max(largestAnswer, item.getBoundingClientRect().height - closed);
          closedHeight += closed;
          item.open = wasOpen;
        });
        this.style.minHeight = Math.ceil(closedHeight + largestAnswer) + 'px';
      };
      requestAnimationFrame(reserveSpace);
      document.fonts.ready.then(reserveSpace);
      this.sizeObserver = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (this.previousWidth !== width) {
          this.previousWidth = width;
          reserveSpace();
        }
      });
      this.sizeObserver.observe(this);
      this.querySelectorAll('details').forEach(detail => {
        detail.targetOpen = detail.open;
        detail.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          const opening = !detail.targetOpen;
          if (opening) this.querySelectorAll('details').forEach(other => {
            if (other !== detail && other.targetOpen) this.transition(other, false);
          });
          this.transition(detail, opening);
        });
      });
    }
    disconnectedCallback() { this.sizeObserver?.disconnect(); }
    transition(detail, opening) {
      const start = detail.getBoundingClientRect().height;
      if (detail.tlAnimation) detail.tlAnimation.cancel();
      detail.targetOpen = opening;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { detail.open = opening; return; }
      detail.open = opening;
      const end = detail.getBoundingClientRect().height;
      detail.open = true;
      const animation = detail.animate([{height:start+'px'},{height:end+'px'}], {duration:340,easing:'cubic-bezier(.22,1,.36,1)'});
      detail.tlAnimation = animation;
      animation.onfinish = () => { detail.open = opening; detail.tlAnimation = null; };
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
